{
  "fr": {
    "texts": {
      "user": {
        "maintainer": "Reçoit le badge de mainteneur et tous les avantages du plus haut niveau de soutien."
      },
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "Pas de budget ? <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Votez pour nous sur Spectrum</b></a> pour aider plus de monde à trouver FleetYards.",
        "goal": "Couvre les frais courants comme l'hébergement et les services de données.",
        "code": "Nouveau sur Star Citizen ? Utilisez ce code pour 5000 UEC de départ :",
        "thisMonth": "sur %{goal} ce mois-ci",
        "subline": "Soutenez-nous directement",
        "otherWays": "Autres façons d'aider"
      },
      "appUpdate": {
        "withCodename": "FleetYards %{version} (%{codename}) est en ligne. Rechargez pour y passer.",
        "plain": "FleetYards %{version} est en ligne. Rechargez pour y passer."
      },
      "installApp": {
        "eventSignup": "Installez FleetYards comme application pour retrouver vos événements en un geste.",
        "iosIntro": "Sur iPhone et iPad, les applications comme FleetYards s'installent depuis le menu Partager :",
        "iosShare": "Touchez le bouton Partager dans la barre du navigateur.",
        "iosAdd": "Choisissez « Sur l'écran d'accueil ». Il faudra peut-être faire défiler vers le bas.",
        "iosConfirm": "Touchez « Ajouter ». FleetYards s'ouvre désormais depuis votre écran d'accueil comme n'importe quelle autre application."
      },
      "supportHint": {
        "hangarSync": "Les synchronisations en arrière-plan sont le plus gros poste de notre facture d'hébergement. FleetYards fonctionne grâce aux dons — chaque contribution compte.",
        "vehicleAdded": "FleetYards est gratuit, sans pub, et vit uniquement grâce aux dons. S'il t'est utile, un petit coup de pouce aide à le maintenir ainsi.",
        "fleetCreated": "Les flottes font partie de nos fonctions les plus gourmandes. FleetYards reste gratuit et sans pub grâce aux dons — envisage d'y contribuer.",
        "loginMilestone": "Tu reviens régulièrement — merci. FleetYards vit grâce aux dons ; si tu veux aider à couvrir les frais, c'est par ici.",
        "visitMilestone": "FleetYards est financé par la communauté — pas de pub, pas de paywall. Si la plateforme t'est utile, un petit don fait une grande différence."
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "Votre autorisation ne couvre pas cette zone. Si une fonctionnalité est en cours de déploiement, vous pourrez l'activer vous-même dans Paramètres > Fonctionnalités dès qu'elle sera disponible.",
      "subscriptionRequired": "Contrats, événements, logistics et expéditions sont financés par celles et ceux qui soutiennent FleetYards. Cette flotte n'est pas couverte pour le moment : la contribution d'un seul membre ouvre les quatre pour toute la flotte.",
      "featureNotReady": "Cette fonctionnalité n'est pas encore prête et sera bientôt disponible. Restez à l'écoute !",
      "inviteInvalid": "Ce lien d'invitation n'est pas valide. Il a peut-être été mal recopié, il a peut-être expiré, ou il a peut-être déjà atteint sa limite d'utilisations. Demandez un nouveau lien à la personne qui vous a invité.",
      "accessDenied": "Vous n'êtes pas autorisé à consulter cette page.",
      "serverError": "Le serveur rencontre actuellement des difficultés techniques. Veuillez réessayer plus tard.",
      "offline": "La requête n'a pas atteint le serveur. Votre appareil semble hors ligne ou le serveur est injoignable. Vérifiez votre connexion et réessayez.",
      "invalidRequest": "Le serveur n'a pas pu traiter cette requête. Rechargez la page et réessayez.",
      "invalidListRequest": "Ce filtre ou ce tri n'est pas valide. Réinitialisez-le pour afficher à nouveau la liste.",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin.",
        "directory": "Des flottes vérifiées qui ont choisi d’être trouvées. Chaque flotte ici a prouvé qu’elle dirige son organisation RSI."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "La restauration d'une flotte purgée est faite au mieux. Les rôles, les images, les liens d'invitation et les véhicules de flotte ne sont pas restaurés."
        },
        "models": {
          "viewsFolder": {
            "hint": "Déposez un dossier de vues nommées top.png, side.png, front.png et angled.png. Suffixe _colored pour le jeu peint, préfixe extended_ pour le jeu étendu et landed_ pour le jeu posé. Le préfixe flight_, ou aucun préfixe, va dans le jeu par défaut. holo.gltf est également pris en charge, avec les mêmes préfixes. Les vues de l'arrière et du dessous s'appellent angled_rear.png, bottom.png, rear.png et starboard.png. holo_lite.glb, le holo sans intérieur, accepte les mêmes préfixes ; holo_textured.glb va uniquement dans le jeu par défaut.",
            "uploading": {
              "one": "Envoi d'un fichier…",
              "other": "Envoi de %{count} fichiers…"
            },
            "matched": {
              "one": "Un fichier prêt — enregistrez pour l'appliquer.",
              "other": "%{count} fichiers prêts — enregistrez pour les appliquer."
            },
            "processing": {
              "one": "Recadrage d'une vue en arrière-plan — elle sera mise à jour ici une fois terminée.",
              "other": "Recadrage de %{count} vues en arrière-plan — elles seront mises à jour ici une fois terminées."
            },
            "processed": "Toutes les vues sont traitées.",
            "ignored": "Ignorés : %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "Le motif est montré à la personne qui a enregistré l'application : indiquez donc ce qui doit changer."
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "Bienvenue dans votre hangar",
          "text": "Votre hangar recense tous les vaisseaux que vous possédez. Cette courte visite vous montre où tout se trouve — vous pouvez la relancer à tout moment depuis le bouton ?."
        },
        "add": {
          "title": "Ajouter des vaisseaux",
          "text": "Choisissez un ou plusieurs vaisseaux et leur nombre. Sur la page ou la carte de chaque vaisseau, l'icône de marque-page l'ajoute aussi à votre hangar ou à votre liste de souhaits."
        },
        "sync": {
          "title": "Synchroniser avec RSI",
          "text": "Synchronisez vaisseaux, peintures, objets décoratifs et équipement depuis RSI avec l’extension FleetYards. Vérifiez le résultat après chaque synchronisation. Les rachats ont leur propre synchronisation sur leur page."
        },
        "display": {
          "title": "Options d'affichage",
          "text": "Basculez entre cartes et liste, définissez votre ordre par défaut et choisissez les détails ou colonnes affichés. Dans la liste, vous pouvez sélectionner plusieurs vaisseaux et les modifier ensemble."
        },
        "groups": {
          "title": "Groupes",
          "text": "Rangez vos vaisseaux dans vos propres groupes avec + et le crayon. Cliquez sur un groupe pour filtrer, survolez-le pour mettre ses vaisseaux en évidence."
        },
        "vehicle": {
          "title": "Le menu de chaque vaisseau",
          "text": "Modifiez un vaisseau d'ici : nommez-le, choisissez sa peinture, faites-en votre vaisseau amiral, réglez sa visibilité, gérez ses loadouts ou déplacez-le vers votre liste de souhaits."
        },
        "wishlist": {
          "title": "Liste de souhaits",
          "text": "Placez les vaisseaux que vous souhaitez acquérir dans votre liste de souhaits, puis déplacez-les dans votre hangar une fois obtenus."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Alignez vos vaisseaux côte à côte à l'échelle et enregistrez le graphique en image."
        },
        "stats": {
          "title": "Statistiques",
          "text": "Rôles, constructeurs, tailles et dépenses, avec un export CSV."
        },
        "share": {
          "title": "Partager votre hangar",
          "text": "Partagez votre hangar public et choisissez les vaisseaux et groupes visibles. Dans les paramètres du hangar, vous pouvez aussi créer, remplacer ou désactiver un lien secret fonctionnant même si votre hangar est privé. Toute personne disposant du lien peut voir votre hangar et ses statistiques."
        },
        "menu": {
          "title": "Plus",
          "text": "Importez ou exportez votre hangar et consultez l’historique des imports. Sur téléphone, ce menu contient aussi la liste de souhaits, le fleetchart, les statistiques, les articles de promesse et cette visite."
        },
        "overview": {
          "title": "La page de votre vaisseau",
          "text": "Cliquez sur le titre du vaisseau pour ouvrir sa vue d’ensemble pour gérer sa configuration et sa visibilité, écrire dans le journal de bord et importer une image. Ajoutez une plaque de dédicace à un vaisseau possédé et enregistrez-la en image. Les entrées du journal ont leurs propres réglages de visibilité."
        },
        "pledgeItems": {
          "title": "Bien plus que des vaisseaux",
          "text": "Ouvrez Peintures, objets décoratifs ou Équipement depuis ce menu pour parcourir les objets synchronisés depuis votre hangar RSI. Les rachats sont répertoriés séparément et se synchronisent depuis leur propre page."
        },
        "reset": {
          "title": "Après une remise à zéro du jeu",
          "text": "Réinitialisez ici les vaisseaux achetés en jeu : déplacez-les tous vers la liste de souhaits pour préparer vos achats, ou retirez-les du hangar. Les vaisseaux achetés avec de l’argent réel restent en place."
        },
        "inventories": {
          "title": "Inventaires du hangar",
          "text": "Suivez les objets sur vos sites, enregistrez les dépôts et les retraits, et gérez les transferts depuis les inventaires du hangar."
        },
        "exampleShip": {
          "title": "Vaisseau d’exemple",
          "text": "Uniquement pour la visite. Ce vaisseau n’est pas enregistré dans votre hangar."
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "Votre flotte est prête",
          "text": "Cette visite ouvre chaque page où elle se configure et montre ce qui compte sur chacune. Le point d'interrogation en haut de la page de la flotte la relance à tout moment."
        },
        "events": {
          "title": "Événements et missions",
          "text": "Planifiez des opérations, laissez les membres s'inscrire sur un vaisseau et un poste, et gardez tout dans le calendrier de la flotte."
        },
        "contracts": {
          "title": "Contrats",
          "text": "Publiez des missions pour vos membres et payez-les une fois terminées."
        },
        "members": {
          "title": "Inviter des membres",
          "text": "Invitez des personnes par leur nom d'utilisateur Fleetyards, ou créez un lien d'invitation à partager sur Discord ou RSI. Les demandes d'adhésion arrivent aussi sur cette page."
        },
        "ships": {
          "title": "Vaisseaux et fleetchart",
          "text": "Les vaisseaux que partagent vos membres forment ensemble ceux de la flotte. Le fleetchart les aligne côte à côte à l'échelle."
        },
        "membership": {
          "title": "Vos vaisseaux dans la flotte",
          "text": "Chaque membre choisit quels vaisseaux la flotte voit : tous, un groupe du hangar ou aucun. Vous faites ici votre propre choix."
        },
        "rsi": {
          "title": "Vérifier votre organisation RSI",
          "text": "Saisissez le SID de votre organisation et vérifiez-le. La vérification prouve que l'organisation vous appartient et protège l'identifiant de votre flotte."
        },
        "roles": {
          "title": "Rôles",
          "text": "Chaque rôle détermine ce que ses membres peuvent voir et gérer. Cette page indique ce que chaque rôle peut faire."
        },
        "squadrons": {
          "title": "Escadrons et équipes",
          "text": "Activez les escadrons pour répartir les membres en unités et en équipes, chacune avec ses propres rangs."
        },
        "discord": {
          "title": "Connecter Discord",
          "text": "Installez le bot sur votre serveur Discord pour donner à chaque rang un rôle Discord et refléter les événements en événements programmés."
        },
        "settings": {
          "title": "Page publique de la flotte",
          "text": "Choisissez si la page de la flotte et ses vaisseaux sont publics ; logo, description et liens se trouvent aussi ici."
        },
        "finish": {
          "title": "Votre flotte est configurée",
          "text": "C'est tout pour commencer. Le point d'interrogation ici en haut relance cette visite à tout moment."
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "Synchroniser avec RSI",
          "text": "Importez vos pledges avec l'extension de navigateur ou un fichier hangarXPLOR au lieu d'ajouter les vaisseaux un par un."
        },
        "organise": {
          "title": "Organiser vos vaisseaux",
          "text": "Nommez vos vaisseaux, définissez peintures, loadouts et vaisseau amiral, et rangez-les dans vos propres groupes."
        },
        "wishlist": {
          "title": "Liste de souhaits et soldes",
          "text": "Gardez les vaisseaux que vous voulez sur une liste de souhaits et soyez prévenu quand ils sont en vente."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Voyez vos vaisseaux côte à côte à l'échelle et enregistrez le graphique en image."
        },
        "stats": {
          "title": "Statistiques du hangar",
          "text": "Rôles, constructeurs, tailles et dépenses, en un coup d'œil."
        },
        "share": {
          "title": "Hangar public",
          "text": "Partagez votre hangar avec un lien — vous décidez quels vaisseaux et groupes sont visibles."
        }
      },
      "fleetPreview": {
        "members": {
          "title": "Membres et rôles",
          "text": "Invitez les membres de votre org avec un lien et organisez-les en rôles et escadrons."
        },
        "ships": {
          "title": "Vaisseaux de la flotte",
          "text": "Les vaisseaux publics de tous les membres dans une liste filtrable et consultable."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Voyez toute la flotte côte à côte à l'échelle et enregistrez-la en image."
        },
        "stats": {
          "title": "Statistiques de la flotte",
          "text": "Analysez votre flotte par rôle, taille et capacité de fret."
        },
        "allies": {
          "title": "Alliés",
          "text": "Alliez-vous à d'autres flottes et gardez une trace de ceux avec qui vous volez."
        },
        "discord": {
          "title": "Discord",
          "text": "Publiez des annonces et un récapitulatif hebdomadaire sur votre serveur Discord, et laissez les membres rejoindre via un rôle."
        }
      },
      "impressum": {
        "visit": "Visite",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "Quelles informations utilisons-nous ?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "En tant qu'invité",
          "text": "En tant qu'invité sur %{app}, nous collectons les données suivantes :"
        },
        "analytics": {
          "headline": "Analyse d'utilisation",
          "basis": "%{app} comptabilise les pages vues afin de comprendre quelles parties du site sont réellement utilisées. Cela repose sur notre intérêt légitime à exploiter et améliorer le site, et non sur votre consentement : les données sont collectées uniquement en interne, les adresses IP sont anonymisées avant d'être stockées, aucun cookie ni autre identifiant n'est déposé sur votre appareil, et rien n'est partagé avec des régies publicitaires.",
          "retention": "Les visites et pages vues individuelles sont supprimées au bout d'un mois. Seuls les décomptes agrégés, qui ne peuvent pas être rattachés à une personne, sont conservés au-delà. La suppression de votre compte supprime également les visites enregistrées pour celui-ci.",
          "objection": {
            "headline": "Comment s'y opposer",
            "text": "Vous pouvez vous opposer à tout moment à l'analyse d'utilisation, et nous cesserons de l'enregistrer plutôt que de simplement la masquer.",
            "user": "Le réglage de votre compte, dans les Paramètres, s'applique à tous les appareils sur lesquels vous vous connectez.",
            "guest": "Sans compte, vous pouvez vous y opposer ici. Nous respectons également le signal Global Privacy Control si votre navigateur en envoie un."
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "Lorsque cette option est activée, nous comptabilisons les pages que vous visitez pour voir quelles parties du site sont utilisées. Les adresses IP sont anonymisées, rien n'est stocké sur votre appareil, et les visites individuelles sont supprimées au bout d'un mois. La désactiver arrête complètement l'enregistrement.",
          "onlineStatus": "Lorsque cette option est activée, les membres de vos flottes et vos amis voient un point à côté de votre nom tant que FleetYards est ouvert. La désactiver le leur masque — rien d'autre ne change, et votre dernière activité reste affichée.",
          "supporterListed": "Choisis si tes dons sont cités sur la page des soutiens. C'est ton nom d'utilisateur qui apparaît, jamais le nom saisi lors du paiement, et les dons masqués comptent toujours pour l'objectif mensuel. En gardant le choix fait lors du don, chaque don Ko-fi conserve ce que tu as choisi là-bas et les contributions Patreon restent masquées."
        },
        "notifications": {
          "hint": "Choisissez comment chaque événement vous parvient. Les notifications de l'application sont regroupées dans votre centre de notifications, les emails sont envoyés à l'adresse de votre compte.",
          "push": {
            "title": "Notifications push",
            "intro": "Recevez des notifications sur cet appareil même lorsque FleetYards est fermé. Choisissez lesquelles arrivent en push dans la colonne Push ci-dessous.",
            "unsupported": "Ce navigateur ne peut pas recevoir de notifications push. Sur un iPhone ou un iPad, ajoutez d'abord FleetYards à l'écran d'accueil et ouvrez-le depuis là.",
            "denied": "Les notifications de FleetYards sont bloquées dans ce navigateur. Autorisez-les dans les paramètres du site du navigateur, puis rechargez cette page.",
            "on": "Les notifications push sont activées sur cet appareil.",
            "off": "Les notifications push sont désactivées sur cet appareil.",
            "device": "%{browser} sur %{os}",
            "unknownDevice": "Navigateur inconnu",
            "thisDevice": "(cet appareil)",
            "failed": "L'état des notifications push n'a pas pu être vérifié sur cet appareil. Rechargez la page pour réessayer."
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "Pour désactiver l'authentification à deux facteurs, entrez simplement un token valide.",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} demande l'accès à votre compte.",
        "scopesIntro": "Cette application pourra :"
      },
      "buybackSync": {
        "info": "Lit chaque page de votre liste de rachat RSI et remplace par celle-ci les pledges rachetables enregistrés sur Fleetyards. Votre hangar n'est pas modifié. Les longues listes prennent quelques minutes. La synchronisation se fait en arrière-plan : vous pouvez fermer cette fenêtre et continuer à utiliser Fleetyards tant que l'onglet reste ouvert.",
        "unsupported": "Votre extension Fleetyards Sync ne sait pas encore lire les pledges rachetables. Mettez-la à jour pour les synchroniser.",
        "detailsInfo": "La première synchronisation lit aussi le prix et l'assurance de chaque pledge, une page RSI par pledge, ce qui peut prendre un quart d'heure pour une longue liste. Les suivantes ne lisent que les nouveaux.",
        "detailsUnsupported": "Mettez à jour votre extension Fleetyards Sync pour lire aussi les prix et les assurances.",
        "detailsIncomplete": "Certains prix n'ont pas pu être lus sur RSI. La prochaine synchronisation réessaiera.",
        "detailsBackground": "Les prix et assurances sont maintenant lus en arrière-plan. Vous pouvez fermer cette fenêtre et continuer à utiliser Fleetyards ; gardez cet onglet ouvert jusqu'à la fin.",
        "detailsRunning": "Les prix et assurances de la dernière synchronisation sont encore en cours de lecture. Une nouvelle synchronisation pourra démarrer une fois celle-ci terminée."
      },
      "addToHangar": {
        "hangarHint": "Vous possédez ce vaisseau.",
        "wishlistHint": "Vous voulez obtenir ce vaisseau plus tard."
      },
      "resetIngame": {
        "info": "Un wipe supprime les vaisseaux que vous avez achetés en jeu. Déplacez-les dans votre liste de souhaits pour les racheter plus tard, ou supprimez-les de votre hangar. Les vaisseaux que vous n'avez pas achetés en jeu restent inchangés."
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "info": "We will try to match the ships from your RSI Hangar with your existing ships in your Fleetyards Hangar by using the name and the pledge-id. Ships from the RSI Hangar without a match will be added to your Fleetyards Hangar.<br><br>Do you want to continue?",
        "alreadyRunning": "Une synchronisation du hangar est déjà en cours. Veuillez attendre qu'elle se termine.",
        "missingUnmatchedGroup": "Choisissez avant de commencer le groupe où classer les vaisseaux que la synchronisation ne trouve pas.",
        "notSyncing": "Hors synchronisation :"
      },
      "setEmail": "Pour définir un mot de passe, activer l'authentification à deux facteurs ou recevoir des notifications par e-mail, vous devez ajouter une adresse e-mail à votre compte. Vous recevrez un e-mail de confirmation pour vérifier l'adresse.",
      "oauthApplications": {
        "pendingReview": "Cette application est enregistrée et attend son examen. Elle ne peut demander aucun accès avant d'être approuvée.",
        "rejected": "Cette application a été refusée et ne peut demander aucun accès. Corriger ce que le motif indique la remet dans la file.",
        "returnedToReview": "Modifier l'URI de redirection ou les portées renvoie une application approuvée à l'examen."
      },
      "payouts": {
        "accountFound": "%{username} a un compte FleetYards et sera lié à ce participant.",
        "accountMissing": "Aucun compte FleetYards ne porte ce nom d'utilisateur. Vérifiez l'orthographe ou ajoutez la personne ci-dessous par son nom, comme invité.",
        "guestHint": "Pour quelqu'un sans compte FleetYards. La personne apparaît comme invitée.",
        "deleteHint": "Personne d'autre ne participe encore à cette expédition, elle peut donc être supprimée.",
        "tourInvite": "%{username} vous invite à rejoindre cette expédition.",
        "contractReady": "Le contrat est rempli. Ouvrez son registre de paiements pour verser la récompense aux prestataires.",
        "contractNotReady": "Aucun registre de paiements n'a encore été ouvert pour ce contrat.",
        "expenseNeedsReview": "Une dépense compte une fois approuvée par la personne qui gère le registre."
      },
      "fleet": {
        "contractCovers": "L'image que le tableau affiche pour chaque type de contrat. Laissez-en une vide et l'image intégrée ci-dessous est utilisée."
      },
      "vehicleLog": {
        "visibility": "Les entrées publiques sont affichées avec ce vaisseau dans ton hangar public.",
        "visibilityHidden": "Ce vaisseau n'apparaît pas dans ton hangar public, aucune de ses entrées n'y est donc affichée.",
        "empty": "Note ce qui est arrivé à ce vaisseau : toi seul vois une entrée tant que tu ne la rends pas publique.",
        "publicEmpty": "Le capitaine de ce vaisseau n'a encore partagé aucune entrée.",
        "noneForFilter": "Aucune entrée ne correspond à ce filtre.",
        "unavailable": "Ce journal n'est pas disponible pour le moment."
      },
      "vehiclePlaque": {
        "supporter": "Tous les autres styles sont un merci à celles et ceux qui font vivre Fleetyards.",
        "keptStyle": "Votre plaque garde son style %{style}, un avantage réservé aux soutiens. L'enregistrer la fait passer en %{default}.",
        "credits": {
          "founders": "Fondateurs de %{manufacturer}",
          "shipwrights": "Constructeurs de %{manufacturer}",
          "designers": "Concepteurs de %{manufacturer}",
          "directors": "Direction de %{manufacturer}"
        },
        "fromFleet": "Depuis une flotte",
        "classLine": "%{model} par %{manufacturer}",
        "commissioned": "Commandé aux %{shipyard}",
        "launched": "Lancé en %{date}",
        "launchedAt": "Lancé en %{date}, %{port}",
        "launchedFrom": "Lancé depuis %{port}",
        "captain": "Capitaine %{name}",
        "captainOf": "Capitaine %{name}, %{affiliation}",
        "year": "%{month} %{year}",
        "empty": "Pas encore de dédicace. Écrivez-en une et le vaisseau aura sa plaque.",
        "visibility": "Tant que ce vaisseau est public, tout le monde peut voir la plaque dans votre hangar public."
      },
      "vehicleOverview": {
        "noLoadouts": "Pas encore de loadout. Ajoutes-en un depuis Erkul ou SPViewer.",
        "locationPrivate": "Toi seul vois où se trouve ton vaisseau.",
        "pickReplacesUpload": "Choisir une image de la galerie ou une peinture remplace celle que tu as téléversée.",
        "galleryEmpty": "Ce vaisseau n'a pas encore d'images dans la galerie."
      },
      "model": {
        "sectionEmpty": "%{model} n'a pas de %{section}."
      }
    }
  }
}
